// extracted by mini-css-extract-plugin
export default {"aliasField":"ProjectDetailsFieldsList_aliasField__IO-V2","buttonsRow":"ProjectDetailsFieldsList_buttonsRow__ZgbB2","originalName":"ProjectDetailsFieldsList_originalName__c4JSX"};